import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { TeamCost } from '../types';

export const updateTeamCostConfirmationById = async ({
  teamCostId,
  data,
}: {
  teamCostId: string;
  data: { isConfirmedByLeader: boolean };
}): Promise<TeamCost> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/sqo-team-cost/${teamCostId}/confirmation`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as TeamCost;
  return response;
};
